/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { NavLink } from 'react-router-dom';
import { PRIVACY_NOTICE_URL, PRIVACY_PORTAL_URL } from 'src/utils/constants';
import { Content, Menu, Left, Right, MailInfo, PrivacyLinks } from './styles';

const Footer: React.FC = () => {
  return (
    <Content>
      <Menu>
        <Left>
          <nav>
            <div className="menu_nav">
              <NavLink exact to="/proposals">
                Inicio
              </NavLink>
            </div>
          </nav>
        </Left>
        <Right>
          <MailInfo>
            <label htmlFor="n1">Entre em contato:</label>
            <strong id="n1">
              <a href="mailto:unio@stone.com.br">unio@stone.com.br</a>
            </strong>
          </MailInfo>
          <PrivacyLinks>
            <a
              href={PRIVACY_NOTICE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Aviso de Privacidade
            </a>
            <a
              href={PRIVACY_PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Portal de Privacidade
            </a>
          </PrivacyLinks>
        </Right>
      </Menu>
    </Content>
  );
};

export default Footer;
